var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "#202020",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 0.378906,
    width: 14.8166,
    height: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.378906 7.5C0.378906 11.6421 3.69571 15 7.78719 15C11.8787 15 15.1955 11.6421 15.1955 7.5C15.1955 3.35786 11.8787 0 7.78719 0C3.69571 0 0.378906 3.35786 0.378906 7.5ZM13.7138 7.5C13.7138 10.8137 11.0604 13.5 7.78719 13.5C4.51401 13.5 1.86056 10.8137 1.86056 7.5C1.86056 4.18629 4.51401 1.5 7.78719 1.5C11.0604 1.5 13.7138 4.18629 13.7138 7.5Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78673 4C7.37758 4 7.0459 4.33168 7.0459 4.74083V4.75917C7.0459 5.16832 7.37758 5.5 7.78673 5.5C8.19588 5.5 8.52756 5.16832 8.52756 4.75917V4.74083C8.52756 4.33168 8.19588 4 7.78673 4ZM8.52756 11V7H7.0459V11H8.52756Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5cb9f439.svg";
export { ForwardRef as ReactComponent };